import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import * as _ from "lodash";
import Editor from "../../components/Editing/Editor";
import TextField from "../../components/Editing/TextField";
import { nameofFactory, hasWriteAccess } from "../../utils/utils";
import { EditActions, editActions } from "../../actions/editActions";

type StateProps = {
  editedEnumeration: Api.IoOptionsEnumType;
  storedEnumeration: Api.IoOptionsEnumType;
  pdApi: State.PdApi;
  activeUser: Api.User | undefined;
};

type DispatchProps = {
  editActions: typeof editActions;
};

type OwnProps = {
  toggleModal: () => void;
  dataFieldName: keyof State.PdApi;
};

interface ErrorStatus {
  errorStatus: boolean;
  errorMsg: string;
}

export type EditIoDatatypeProps = StateProps & DispatchProps & OwnProps;

const baseEnumFields = nameofFactory<Api.IoOptionsEnumType>();

export class EditIoDatatype extends React.Component<EditIoDatatypeProps> {
  render(): JSX.Element {
    const {
      editedEnumeration,
      storedEnumeration,
      activeUser,
      toggleModal,
      dataFieldName
    } = this.props;

    const permission = hasWriteAccess(activeUser, "Lift");
    const errorenumTypeName = this.isFieldValid(baseEnumFields("enumTypeName"));
    return (
      <Editor
        itemName={"Enum Option Name"}
        originalObject={storedEnumeration}
        editedObject={editedEnumeration}
        hasWritePermission={hasWriteAccess(activeUser, "Lift")}
        isValid={this.isAllFieldsValid()}
        cancel={this.props.editActions.cancelEditing}
        update={() => this.props.editActions.update(dataFieldName as Api.OptionsGrud)}
        create={() => this.props.editActions.add(dataFieldName as Api.OptionsGrud)}
        remove={{ callback: toggleModal }}
      >
        {storedEnumeration && (
          <TextField
            id="EnumID"
            label="EnumID"
            value={editedEnumeration.enumID.toString()}
            isError={false}
            errorMessage={""}
            readonly={true}
            onChange={() => {
              // do nothing
            }}
          />
        )}
        <TextField
          id="enumTypename"
          label="Enum Option Name"
          value={editedEnumeration.enumTypeName}
          isError={errorenumTypeName.errorStatus}
          errorMessage={errorenumTypeName.errorMsg}
          onChange={enumTypeName =>
            storedEnumeration
              ? this.props.editActions.setEdited({
                  ...editedEnumeration,
                  enumTypeName: enumTypeName
                })
              : this.props.editActions.setEdited({ enumTypeName: enumTypeName })
          }
          readonly={!permission}
        />
      </Editor>
    );
  }

  private isEmptyString = (str: string): boolean => !(!!str && str.replace(/\s/g, "").length > 0);

  private checkSpecialCharacters = (str: string): boolean =>
    !/^(?=.*[a-zA-Z0-9])[a-zA-Z0-9_]+$/.test(str);

  private isFieldValid = (field: string): ErrorStatus => {
    const { editedEnumeration, storedEnumeration, pdApi } = this.props;
    const isNew = !storedEnumeration;
    switch (field) {
      case baseEnumFields("enumTypeName"): {
        const { enumTypeName } = editedEnumeration;

        if (this.isEmptyString(enumTypeName)) {
          return { errorStatus: true, errorMsg: "The enumTypeName name cannot be empty." };
        } else if (this.checkSpecialCharacters(enumTypeName)) {
          return {
            errorStatus: true,
            errorMsg: "The enumTypeName name must contain only alphabets numbers and underscores"
          };
        } else {
          return _.values(pdApi[this.props.dataFieldName]).find(
            enumeration =>
              (isNew || enumeration.enumID !== editedEnumeration.enumID) &&
              enumeration.enumTypeName.trim().toLowerCase() ===
                editedEnumeration.enumTypeName.trim().toLowerCase()
          )
            ? { errorStatus: true, errorMsg: "The enumTypeName name must be unique." }
            : { errorStatus: false, errorMsg: "" };
        }
      }

      default:
        return { errorStatus: false, errorMsg: "" };
    }
  };

  private isAllFieldsValid = (): boolean => {
    const { editedEnumeration } = this.props;
    const temp = _.keys(editedEnumeration);
    for (const key of temp) {
      if (this.isFieldValid(key).errorStatus) {
        return false;
      }
    }
    return true;
  };
}

const mapStateToProps = (state: State.Root) => ({
  editedEnumeration: state.editView.editedObject,
  storedEnumeration: state.editView.storedObject,
  pdApi: state.pdApi,
  activeUser: state.main.activeUser
});

const mapDispatchToProps = (dispatch: Dispatch<EditActions>) => ({
  editActions: bindActionCreators({ ...editActions }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(EditIoDatatype);


